import Avatar from "@pathwright/ui/src/components/avatar/Avatar"
import OptionsButton from "@pathwright/ui/src/components/button/OptionsButton"
import DropdownTrigger from "@pathwright/ui/src/components/dropdown/DropdownTrigger"
import Link from "@pathwright/ui/src/components/link/Link"
import {
  ENROLLMENT_ROLE_STUDENT,
  ROLE_LABELS,
  ROLE_TYPE_OFFERING
} from "@pathwright/web/src/modules/invitation/constants"
import { ConnectStores } from "lib/core/store"
import capitalize from "lodash/capitalize"
import PropTypes from "prop-types"
import MemberControls from "./MemberControls"
import MemberInlineStats from "./MemberInlineStats"
import "./MemberListItem.css"
import MemberRemove from "./MemberRemove"

const MemberListItem = (props, context) => {
  const {
    member,
    isRemoving,
    toMember,
    toMessageMember,
    style,
    controlsPlacement
  } = props
  const { user, role, last_activity_time } = member
  const last_activity = last_activity_time
    ? `Last active here ${moment(last_activity_time).fromNow()}`
    : `Not recently active`

  return (
    <div className="MemberListItem" style={style}>
      <div className="MemberListItem__wrapper">
        <Link className="MemberListItem__link" to={toMember} />
        <Avatar user={user} size="30px" />
        <div className="MemberListItem__info">
          <label>{user.full_name} </label>
          <div className="MemberListItem__meta">
            <span>
              {capitalize(ROLE_LABELS[ROLE_TYPE_OFFERING][member.role])}
            </span>
            {last_activity && <span>{last_activity}</span>}
            {user.profile.location && <span>{user.profile.location}</span>}
          </div>
        </div>
        {role >= ENROLLMENT_ROLE_STUDENT && (
          <MemberInlineStats member={member} />
        )}
        <DropdownTrigger
          placement={controlsPlacement || "bottom"}
          renderDropdown={() => (
            <MemberControls member={member} toMessageMember={toMessageMember} />
          )}
        >
          <OptionsButton className="MemberControls" />
        </DropdownTrigger>
      </div>
      {isRemoving && <MemberRemove member={member} />}
    </div>
  )
}

MemberListItem.displayName = "MemberListItem"

MemberListItem.contextTypes = {
  user: PropTypes.object
}

const mapStateToProps = (state, ownProps) => {
  const { member } = ownProps
  const { member_removing } = state.memberStore.state
  const isRemoving = member && member.id === member_removing
  const baseUrl = window.location.pathname
  const toMember = `${baseUrl}${member.user.id}/${member.path}/`
  const toMessageMember = `${baseUrl}message/${member.user && member.user.id}/`

  return _.assign(
    {},
    {
      isRemoving,
      toMember,
      toMessageMember
    },
    ownProps
  )
}

const stores = [{ store: "member", watch: ["member_removing"] }]

export default ConnectStores(MemberListItem, stores, {}, mapStateToProps)
